import { inputStyle, mainBox, titleStyle } from "../css/dinamic/modal";
import { checkDate } from "../functions/checkDate";
import Select from "react-select";
import CalendarTable from "./CalendarTable";

const formatOptionLabel = ({ label, color, calendar }, { context }) => (
  <div>
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      {color && (
        <div
          style={{
            width: "16px",
            height: "16px",
            backgroundColor: color,
            marginRight: "8px",
            border: "1px solid #ccc",
          }}
        />
      )}
      <span style={{ fontSize: 18, height: label === "" ? 20 : null }}>
        {label}
      </span>
    </div>
    {calendar && context === "menu" && <CalendarTable data={calendar} />}
  </div>
);

export default function StdInput({
  refId = null,
  placeholder = "",
  label = false,
  value,
  onClick,
  change,
  type,
  style = {},
  maxLength = null,
  select = null,
  textArea = null,
}) {
  return (
    <div className="centerBox" style={{ ...mainBox(), ...style }}>
      {label && <div style={titleStyle()}>{label}</div>}
      {select && Array.isArray(select) ? (
        <div style={{ width: "100%" }}>
          <Select
            value={value}
            onChange={change}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            formatOptionLabel={formatOptionLabel}
            options={select}
            placeholder={placeholder}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                ...inputStyle({ padding: 0 }),
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 1300,
              }),
            }}
          />
        </div>
      ) : textArea ? (
        <textarea
          value={value ?? ""}
          onChange={change}
          style={inputStyle({
            fontSize: 20,
            height: 300,
            resize: "none",
            textWrap: "break-word",
          })}
          placeholder={placeholder}
        />
      ) : type === "year-month" ? (
        <div style={inputStyle({ padding: 4 })} onClick={onClick}>
          {checkDate([...value, null], "monthsFullName")}
        </div>
      ) : (
        <input
          ref={refId}
          placeholder={placeholder}
          style={inputStyle()}
          value={type === "password" ? value : value ?? ""}
          onChange={change}
          type={type ?? "text"}
          maxLength={maxLength}
        />
      )}
    </div>
  );
}
